<template>
  <ul :class="$style.root">
    <li
      v-for="entry in data"
      :key="entry?.id"
      :class="$style.item"
    >
      <i18nLink
        :to="routeObject(entry?.id)"
        :class="$style.link"
        :data-active="route?.query?.tagId === String(entry?.id) ? '' : null"
      >
        <span>{{ entry?.attributes?.label?.trim() }}</span> ({{ entry?.attributes?.journalEntries?.data?.length }})
      </i18nLink>
    </li>
    <li
      v-if="route?.query?.tagId"
    >
      <i18nLink
        :to="routeObject()"
        :class="[$style.link, $style.removeFilter]"
      >
        {{ $t('shared.removeFilter') }}
      </i18nLink>
    </li>
  </ul>
</template>

<script lang="ts" setup>
import { omit } from 'lodash-es'
const route = useRoute()

const props = defineProps({
  data: {
    type: Array,
    required: true
  }
})

const routeObject = (id) => {
  const tagIdQuery = route?.query?.tagId === String(id) ? {} : { tagId: id }
  const queryObject = omit(filterRouteQuery(route.query), 'tagId')
  return {
    name: 'journals',
    query: { ...queryObject, ...tagIdQuery }
  }
}
</script>

<style module>
.root {
  composes: reset-list font-size-small font-helvetica container from global;

  display: flex;
  flex-wrap: wrap;
  gap: 1.25ch;

  margin-bottom: var(--unit--vertical);
}

.item {
  cursor: pointer;
}

.link {
  composes: reset-link from global;
}

.link:not([data-active]) {
}

.link:not([data-active]):hover span,
.link[data-active] span {
  text-decoration-line: underline;
}

.removeFilter {
  text-decoration-line: underline;
}

.removeFilter:hover {
  text-decoration-line: none;
}
</style>
